export const hasBeenSeen = (article, articlesSeen) => {
  const { contentful_id } = article
  return articlesSeen.includes(contentful_id) ? true : false
}
